module.exports = __webpack_public_path__ + "fonts/OpenSans-Regular.1b0809d.ttf";